import React from 'react'
import {useNavigate} from 'react-router-dom'

export default function DeptCard({deptName="Department Name", deptButtons = [], deptButtonRoutes= ["/", "/", "/"], image='company-logo.jpg'}) {

  const navigate = useNavigate()
  return (
  <>

    <div className="dept-card">
      <div className="dept-image-container"><div className={`dept-image ${image}`}></div></div>
      <div className='dept-title'>{deptName}</div>
      <div className='dept-line'></div>
      <div className='dept-resources'>
        {deptButtons.map((button, idx) => 
          <>
            <div className='dept-button' key={idx} onClick={()=>{navigate(`${deptButtonRoutes[idx]}`)}}>{button}</div>   
          </>
        )}
      </div>
    </div>
  </>
  )
}
